import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PeiData } from '../../types/PEI';

interface PeiState {
  id: string | null;
  data: PeiData | null;
  isLoading: boolean;
  lastUpdatedAt: string | null;
}

const initialState: PeiState = {
  id: null,
  data: null,
  isLoading: false,
  lastUpdatedAt: null,
};

const peiSlice = createSlice({
  name: 'peiId',
  initialState,
  reducers: {
    setPeiId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    clearPeiId: state => {
      state.id = null;
    },

    setPeiData: (state, action: PayloadAction<PeiData | null>) => {
      state.data = action.payload;
      state.lastUpdatedAt = new Date().toISOString();
    },
    clearPeiData: state => {
      state.data = null;
      state.lastUpdatedAt = null;
    },

    setPeiLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    clearPeiState: state => {
      state.id = null;
      state.data = null;
      state.isLoading = false;
      state.lastUpdatedAt = null;
    },
  },
});

export const {
  setPeiId,
  clearPeiId,
  setPeiData,
  clearPeiData,
  setPeiLoading,
  clearPeiState,
} = peiSlice.actions;

export default peiSlice.reducer;
